module.exports = __webpack_public_path__ + "assets/img/pic_scancode.1045dbbb.jpg";